import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const INSTAGRAM_URL = 'https://www.instagram.com/na.lilu';
const images = ['https://cdn.magicpatterns.com/uploads/wukPzrmimUooozenx3Ng1W/photo_5301161740299082105_y.jpg', 'https://cdn.magicpatterns.com/uploads/srnnnzfhLVyKMEsG427we1/photo_5301161740299082098_y.jpg', 'https://cdn.magicpatterns.com/uploads/3RHZLnZixFT9q1yYBx9BcA/photo_5301161740299082089_y.jpg', 'https://cdn.magicpatterns.com/uploads/8uMawBaPh3jYfskiYnQ2CF/photo_5301161740299082106_x.jpg', 'https://cdn.magicpatterns.com/uploads/pZoVMPpgbt8eaaMVMQbv5n/photo_5301161740299082084_y.jpg', 'https://cdn.magicpatterns.com/uploads/aJ1VNaukSeUvgoCqRSMMt5/photo_5301161740299082091_y.jpg'];
export function InstagramGallery() {
  return <section className="py-24 bg-brand-cream" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-248">
          <div data-id="element-249">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-250">
              Приєднуйтесь до нашої спільноти
            </h2>
            <p className="text-brand-dark/70" data-id="element-251">
              Слідкуйте за нами в Instagram для щоденного натхнення та новинок.
            </p>
          </div>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center gap-2 text-brand-burgundy font-medium hover:text-brand-burgundy/80 transition-colors" data-id="element-252">
            <Instagram className="w-5 h-5" data-id="element-253" />
            @na.lilu
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-254">
          {images.map((img, index) => <motion.a key={index} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="group relative aspect-square overflow-hidden rounded-xl block" data-id="element-255">
              <img src={img} alt="Публікація в Instagram" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-256" />
              <div className="absolute inset-0 bg-brand-dark/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-257">
                <Instagram className="w-8 h-8 text-white" data-id="element-258" />
              </div>
            </motion.a>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-259">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-burgundy font-medium" data-id="element-260">
            <Instagram className="w-5 h-5" data-id="element-261" />
            Стежити за @na.lilu
          </a>
        </div>
      </div>
    </section>;
}